"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMod11CheckDigit = calculateMod11CheckDigit;
exports.calculateMod11CheckDigitWithWeights = calculateMod11CheckDigitWithWeights;
exports.isValidCheckDigit = isValidCheckDigit;
exports.isValidCheckDigitWithWeights = isValidCheckDigitWithWeights;
exports.getDefaultMod11WeightsForLength = getDefaultMod11WeightsForLength;
function calculateMod11CheckDigit(digits, threshold) {
    const sum = digits
        .slice(0, -1)
        .reverse()
        .reduce((acc, x, i) => acc + x * ((i % (threshold - 1)) + 2), 0);
    return (11 - (sum % 11)) % 11;
}
function calculateMod11CheckDigitWithWeights(digits, weights) {
    if (digits.length !== weights.length) {
        throw new Error("Digits and weights arrays must be of the same length.");
    }
    const weightedSum = digits.reduce((sum, digit, index) => {
        var _a;
        return sum + digit * ((_a = weights[index]) !== null && _a !== void 0 ? _a : 0);
    }, 0);
    const mod11 = weightedSum % 11;
    const checkDigit = mod11 === 0 ? 0 : 11 - mod11;
    return checkDigit;
}
function isValidCheckDigit(value) {
    const digits = value.split("").map(Number);
    const checkDigit = calculateMod11CheckDigit(digits, 7);
    return checkDigit === digits.pop();
}
function isValidCheckDigitWithWeights(value, weights) {
    const digits = value.split("").map(Number);
    const checkDigit = calculateMod11CheckDigitWithWeights(digits, weights);
    return checkDigit === digits.pop();
}
function getDefaultMod11WeightsForLength(length) {
    let w = 2;
    const weights = [];
    for (let i = 0; i < length; i++) {
        weights.push(w);
        w = w >= 7 ? 2 : w + 1;
    }
    return weights.reverse();
}
//# sourceMappingURL=index.js.map